import React from "react";
import Typography from "@material-ui/core/Typography";
import { CLELoggerTestingForm } from "../../components/Administration/CLELoggerPage/CLELoggerTestingForm";
import { TWILIO_PRODUCT_ID, CLE_TYPES } from "../../constants";
import { getExternalLoggerURI } from "../../services/api/cleLogger.api";
import { Fetcher } from "../../components/Fetcher";

/**
 * Display CLELogger test form.
 */
export const CLELoggerTestPage = () => {
	const cleType = CLE_TYPES[1];

	return (
		<div>
			<Typography style={{ marginBottom: 24 }} variant="h4" data-testid="cle-logger-test-page">
				CLE Logger Testing
			</Typography>
			<Fetcher hidden={true} action={getExternalLoggerURI(cleType)}>
				{(response) => (
					<CLELoggerTestingForm productId={TWILIO_PRODUCT_ID} cleType={cleType} externalLoggerURI={response.data} />
				)}
			</Fetcher>
		</div>
	);
};
